module.exports = __webpack_public_path__ + "files/SPIADI2026 - OBSERVA4 - Fiche R1 (Version 1).777123400db1a8de0a1d3909728b8e8b.pdf";